import { render, staticRenderFns } from "./PlanExpiresIn.vue?vue&type=template&id=e6c80910"
import script from "./PlanExpiresIn.vue?vue&type=script&lang=js"
export * from "./PlanExpiresIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports